var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('HotLoaderPage'):(['en'].includes(_vm.$i18n.locale))?_c('HotHome',{attrs:{"prop-bus":{ breadcrumbs: _vm.breadcrumbs }}}):(['pt-br'].includes(_vm.$i18n.locale))?_c('HotHomeBrazil',{attrs:{"prop-bus":{ breadcrumbs: _vm.breadcrumbs }}}):_c('HotHomeLatam',{attrs:{"prop-bus":{ breadcrumbs: _vm.breadcrumbs }}})
}
var staticRenderFns = []

export { render, staticRenderFns }